import comp from "./AIAssessmentTools";
export default comp;
